import { api } from './_apiInterface';
import { pointer } from 'src/app-config';

class AiAgentServices {
    private Base = pointer.aiAgent;
    //
    ExecuteCommands = async (text: string) => {
        const data = await api.SendRequest<{ aiAgentResponse: string; }>(this.Base, 'POST', { text });
        return data;
    }
}

export const aiAgentServices = new AiAgentServices();
